import { computed, observable, action } from 'mobx';
import { ViewController } from 'elc-service';
import { Config } from '../domain/entities/Config';
import { IOlapicWidget } from '../../exported/olapic/OlapicWidget';

export class OlapicWidgetViewController extends ViewController {
    @observable public config: Config;
    @observable public isLoading: boolean = true;
    private productId: string;
    private olapicConfigInstanceKey: string;
    private olapicConfigApiKey: string;

    constructor(config: Config) {
        super();
        this.config = config;
    }

    @action
    public initialize = (props: IOlapicWidget) => {
        const { olapicConfigInstanceKey, olapicConfigApiKey, productId } = props.config;
        this.olapicConfigInstanceKey = olapicConfigInstanceKey;
        this.olapicConfigApiKey = olapicConfigApiKey;
        this.productId = productId;
    };

    @computed
    get data() {
        return {
            isLoading: this.isLoading
        };
    }

    @computed
    public get configData() {
        const { config } = this.config;

        return config;
    }

    public showElementOnViewportIntersection = () => {
        const {
            olapicWidgetId,
            olapicWidgetSrc,
            olapicInstanceKey,
            olapicApiKey
        } = this.configData;
        const { olapicConfigInstanceKey, olapicConfigApiKey, productId } = this;
        const olapicScript = document.createElement('script');
        const olapicContentElement = <HTMLElement>document.querySelector('.elc-olapic-v1__content');
        const olapicWrapper = <HTMLElement>document.querySelector('.elc-olapic-v1');
        const olapicWidget = document.createElement('div');

        const intersectionObserver = new IntersectionObserver(
            ([entry]) => {
                if (entry.intersectionRatio > 0 && entry.isIntersecting) {
                    this.isLoading = false;
                    olapicWidget.id = olapicWidgetId;
                    olapicScript.src = olapicWidgetSrc;
                    olapicScript.dataset.olapic = olapicWidgetId;
                    olapicScript.async = true;
                    if (olapicConfigInstanceKey) {
                        olapicScript.dataset.instance = olapicConfigInstanceKey;
                        olapicContentElement.appendChild(olapicScript);
                    } else {
                        olapicScript.dataset.instance = olapicInstanceKey;
                        olapicContentElement.appendChild(olapicScript);
                    }
                    if (olapicConfigApiKey) {
                        olapicScript.dataset.apikey = olapicConfigApiKey;
                        olapicContentElement.appendChild(olapicScript);
                    } else {
                        olapicScript.dataset.apikey = olapicApiKey;
                        olapicContentElement.appendChild(olapicScript);
                    }

                    if (!!productId) {
                        olapicScript.dataset.tags = productId;
                    }
                    olapicContentElement.appendChild(olapicWidget);
                    olapicContentElement.appendChild(olapicScript);

                    if (olapicWrapper && olapicScript.src) {
                        intersectionObserver.disconnect();
                        intersectionObserver.unobserve(olapicWrapper);
                    }
                }
            },
            {
                root: null,
                rootMargin: '300px',
                threshold: 0.1
            }
        );

        if (olapicWrapper) {
            intersectionObserver.observe(olapicWrapper);
        }
    };
}
